import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import BarChartIcon from "@mui/icons-material/BarChart";
import SensorsIcon from "@mui/icons-material/Sensors";

type SubRoute = {
  main: Omit<Route, "icon" | "subs">;
  children: (Omit<Route, "icon" | "subs"> & {
    action?: "create" | undefined;
  })[];
};

type Route = {
  label: string;
  icon: React.ReactNode;
  href: string;
  subs: SubRoute[];
};

export const routes: Route[] = [
  {
    label: "Control Planes",
    icon: <MonitorHeartOutlinedIcon fontSize="small" />,
    href: "/dashboards",
    subs: [
      {
        main: {
          label: "Control Planes",
          href: "/dashboards",
        },
        children: [
          {
            label: "Control Plane list",
            href: "/dashboards",
          },
          {
            label: "New Control Plane",
            action: "create",
            href: "/dashboards?dialog=new-dashboard",
          },
        ],
      },
    ],
  },
  {
    label: "Event Analytics",
    icon: <BarChartIcon fontSize="small" />,
    href: "/event-analytics",
    subs: [],
  },
  {
    label: "War Room",
    icon: <SensorsIcon fontSize="small" />,
    href: "/war-room",
    subs: [],
  },
  {
    label: "Configuration",
    icon: <SettingsIcon fontSize="small" />,
    href: "/config",
    subs: [
      {
        main: {
          label: "Tool integrations",
          href: "/config/tool-integrations",
        },
        children: [
          {
            label: "Integrations list",
            href: "/config/tool-integrations",
          },
          {
            label: "New integration",
            action: "create",
            href: "/config/tool-integrations?dialog=new-integration",
          },
        ],
      },
      {
        main: {
          label: "Alerts",
          href: "/config/alerts",
        },
        children: [
          {
            label: "Alert list",
            href: "/config/alerts",
          },
        ],
      },
      {
        main: {
          label: "Alert schemas",
          href: "/config/alert-schemas",
        },
        children: [
          {
            label: "Alert schema list",
            href: "/config/alert-schemas",
          },
          {
            label: "New alert schema",
            action: "create",
            href: "/config/alert-schemas?dialog=new-alert-schema",
          },
        ],
      },
      {
        main: {
          label: "Service templates",
          href: "/config/service-templates",
        },
        children: [
          {
            label: "Service templates list",
            href: "/config/service-templates",
          },
          {
            label: "New service template",
            action: "create",
            href: "/config/service-templates?dialog=new-service-template",
          },
        ],
      },
      {
        main: {
          label: "KPIs",
          href: "/config/kpis",
        },
        children: [
          {
            label: "KPIs list",
            href: "/config/kpis",
          },
          {
            label: "New KPI",
            action: "create",
            href: "/config/kpis?dialog=new-kpi",
          },
        ],
      },
      {
        main: {
          label: "Users",
          href: "/config/users",
        },
        children: [
          {
            label: "Users list",
            href: "/config/users",
          },
          {
            label: "Invite user",
            action: "create",
            href: "/config/users?dialog=invite-user",
          },
        ],
      },
    ],
  },
];
